export default function getEnumKeyByEnumValue(
  myEnum: { [s: string]: string },
  enumValue: number | string
): string {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const keys = Object.keys(myEnum).filter((x) => myEnum[x] === enumValue);
  return keys.length > 0 ? keys[0] : "";
}
